<template lang="pug">
  div
    sidebar
      transition-group.group-list(
        name="list-complete",
        mode="out-in",
        tag="ul")
        li.list-complete-item(key="downloads")
          router-link.group-link(:to="{name: 'downloads'}")
            //icon(name="download")
            span {{$t('download')}}
        //- li.list-complete-item(key="faq", v-if="!AppState.isStandalone")
          a.group-link(target="_blank", href="https://linkmemine.co.kr/faqs.html")
            //icon(name="question-circle")
            span FAQ
        li.list-complete-item(key="notice")
          router-link.group-link(:to="{name: 'notice'}")
            //icon(name="exclamation-circle")
            span {{$t('notice')}}
        //li.list-complete-item(key="tutorial", @click="openTutorial", v-if="AppState.useTutorial")
        //  span.group-link(style="cursor:pointer")
        //    //icon(name="book")
        //    span {{$t('tutorial')}}
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from "../mixins/sidebar"

export default {
  name: "support-component",
  components: { sidebar: Sidebar },
  methods: {
    openTutorial() {
      this.AppState.$emit("open-tutorial")
    },
  },
}
</script>

<style lang="scss" scoped>
//.group-list {
//  margin: 0; padding: 0;
//  list-style: none;
//  font-size: 14px;
//
//  li {
//    height: 40px;
//    line-height: 38px;
//
//    .group-link {
//      display: block;
//      width: 100%;
//      padding: 0 8px 0 16px;
//      text-align: left;
//      font-weight: 200;
//      color: #869fb1;
//
//      &.router-link-active,
//      &.router-link-exact-active {
//        color: #ffffff;
//        background-color: #38d2b8;
//        > span { font-weight: 300; }
//      }
//      &:hover {
//        // background-color: #16232d;
//        color: #fff;
//      }
//      > svg { vertical-align: middle; }
//      > span {
//        display: inline-block;
//        padding: 1px 10px;
//        vertical-align: top;
//      }
//    }
//
//    &.active .group-link {
//      background-color: #38d2b8;
//      color: #fff;
//    }
//  }
//}
//
//.list-complete-item {
//  transition: transform 500ms;
//}
//.list-complete-enter {
//  transform: translateX(-220px);
//}
//.list-complete-leave-to {
//  // transform: translateX(220px);
//  display: none;
//}
//.list-complete-leave-active {
//  // position: absolute;
//}
.group-list {
  padding: 0;
  margin: 15px 0 0 9px;
  list-style: none;
  font-size: 14px;

  li {
    height: 40px;
    line-height: 38px;

    .group-link {
      display: block;
      width: 100%;
      padding: 0 0 0 12px;
      text-align: left;
      font-weight: 400;
      color: #6f6f6f;

      &.router-link-exact-active,
      &.router-link-active {
        color: #ec7211;
        //background-color: #38d2b8;
        > span {
          font-weight: bolder;
        }
      }
      &:hover {
        // background-color: #16232d;
        color: #16191f;
      }
      > svg {
        vertical-align: middle;
      }
      > span {
        display: inline-block;
        padding: 1px 10px;
        vertical-align: top;
      }
    }
  }
}

.list-complete-item {
  transition: transform 500ms;
}
.list-complete-enter {
  transform: translateX(-220px);
}
.list-complete-leave-to {
  // transform: translateX(220px);
  display: none;
}
.list-complete-leave-active {
  // position: absolute;
}
</style>
